module.exports = __webpack_public_path__ + "img/time-range.4a869bcb.svg";